var tienda = function () {
    var navegacion = document.querySelector('.archivo-navegacion');
    if (!navegacion) {
        return;
    }
    var relaciones = Array.from(navegacion.querySelectorAll('a'))
        .map(function (enlace) {
        var href = enlace.getAttribute('href');
        if (!href || !href.startsWith('#')) {
            return undefined;
        }
        var categoria = document.getElementById(href.slice(1));
        return categoria ? { enlace: enlace, categoria: categoria } : undefined;
    })
        .filter(function (relacion) { return Boolean(relacion); });
    if (relaciones.length === 0) {
        return;
    }
    var enlaceActivo;
    var actualizaActivo = function () {
        var visibles = relaciones.map(function (_a) {
            var categoria = _a.categoria;
            var rect = categoria.getBoundingClientRect();
            var arriba = Math.max(0, rect.top);
            var abajo = Math.min(window.innerHeight, rect.bottom);
            return Math.max(0, abajo - arriba);
        });
        var mayorVisibilidad = Math.max.apply(Math, visibles);
        if (mayorVisibilidad <= 0) {
            return;
        }
        var indiceActivo = visibles.indexOf(mayorVisibilidad);
        var indiceAnterior = enlaceActivo
            ? relaciones.findIndex(function (_a) {
                var enlace = _a.enlace;
                return enlace === enlaceActivo;
            })
            : -1;
        if (indiceAnterior !== -1 && visibles[indiceAnterior] === mayorVisibilidad) {
            indiceActivo = indiceAnterior;
        }
        relaciones.forEach(function (_a, indice) {
            var enlace = _a.enlace;
            var activo = indice === indiceActivo;
            enlace.classList.toggle('is-activo', activo);
            if (activo) {
                enlace.setAttribute('aria-current', 'location');
                enlaceActivo = enlace;
            }
            else {
                enlace.removeAttribute('aria-current');
            }
        });
    };
    var actualizacionPendiente;
    var programaActualizacion = function () {
        if (actualizacionPendiente !== undefined) {
            return;
        }
        actualizacionPendiente = window.requestAnimationFrame(function () {
            actualizacionPendiente = undefined;
            actualizaActivo();
        });
    };
    actualizaActivo();
    window.addEventListener('scroll', programaActualizacion, { passive: true });
    window.addEventListener('resize', programaActualizacion);
    window.addEventListener('load', programaActualizacion);
};
export default tienda;
